module.exports = __webpack_public_path__ + "static/media/watch_online.78325541.png";